import { useContext, useRef } from "react";
import Form from "react-bootstrap/Form";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";

//Common
import { TextField, Autocomplete, Chip } from "../../common/VFX-UI";
import ActionBar from "../../common/ActionBar/ActionBar";

//App
import { StateFormProps } from "../../../types/state";
import FormBackGround from "../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../common/Forms/FormHeader/FormHeader";
import { StatesContext } from "./StatesContainer";
import { EMPTY_GUID } from "../../../utility/constants/constants";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .max(250, "Max 250 characters are allowed."),
  description: Yup.string()
    .required("Description is required")
    .max(1500, "Max 1500 characters are allowed."),
  abbreviation: Yup.string()
    .required("Abbreviation is required")
    .max(25, "Max 25 characters are allowed."),
  capital: Yup.string()
    .required("Capital is required")
    .max(150, "Max 150 characters are allowed."),
  regionId: Yup.array()
    .min(1, "Region is required")
    .required("Region is required"),
});

const StateForm = (props: StateFormProps) => {
  const { status, handleOnSubmit, initialVal, onClose } = props;
  const formRef = useRef<FormikProps<any>>(null);
  const stateContext = useContext(StatesContext);
  let lookupOptions: any = [];
  if (stateContext?.lookupsData) {
    lookupOptions = stateContext?.lookupsData?.map((item: any) => ({
      value: item.id,
      label: item.name,
    }));
  }

  const options = [...lookupOptions];

  const saveInput = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  return (
    <FormBackGround>
      <FormHeader
        title={initialVal?.id !== EMPTY_GUID ? "Edit State" : "Add State"}
        onClose={onClose}
      />
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={initialVal}
        validationSchema={validationSchema}
        innerRef={formRef}
      >
        {({ values }) => (
          <Form noValidate>
            <div className="d-flex justify-content-end mb-3 me-3">
              <Chip label={values.isActive ? "Active" : "Inactive"} />
            </div>
            <TextField label="Name" type="text" name="name" />

            <TextField label="Description" type="textarea" name="description" />

            <TextField label="Abbreviation" type="text" name="abbreviation" />
            <TextField label="Capital" type="text" name="capital" />
            <Autocomplete
              name="regionId"
              label="Region"
              isRequired={true}
              options={options}
              defaultSelected={
                  initialVal.regionId != null && initialVal.regionId.length > 0
                      ? [initialVal.regionId[0]]
                      : []
              }
            />
            <TextField label="Display Order" type="text" name="sortValue" />

            <ActionBar
              submitHandler={saveInput}
              cancelHandler={onClose}
              submitText="Submit"
              cancelText="Cancel"
              isLoading={status === "pending"}
            ></ActionBar>
          </Form>
        )}
      </Formik>
    </FormBackGround>
  );
};

export default StateForm;
